import { combineReducers } from "redux";
import { favoriteCoinsReducer } from "./favoriteCoinsReducer";
import { CoinListReducer, marketReducer } from "./market";
import { userId } from "./userIdReducer";
import { coinReducer } from "./coinReducer";
import { loadingPageReducer } from "./loadingPageReducer";
import { fullUserInfoReducer } from "./fullUserInfoReducer";
import { ticketsTextReducer } from "./ticketsTextReducer";
import { coinNetworkReducer } from "./coinNetworkReducer";
import { applicationTheme } from "./applicationTheme";
export const reducers = combineReducers({
  userId,
  market: marketReducer,
  coins: CoinListReducer,
  favCoins: favoriteCoinsReducer,
  coinInfo: coinReducer,
  loadingBar: loadingPageReducer,
  fullUserInfo: fullUserInfoReducer,
  ticketText: ticketsTextReducer,
  network: coinNetworkReducer,
  appTheme: applicationTheme,
});
